import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESOURCES } from 'OpsCenter/app.constants';


/**
 * @desc Service class to handle chain tasks
 * @author {andre.pitombeira}
 */
@Injectable()
export class ChainService {
  PAGINATION_LIMIT = 50;
  merchantsSegment = '/merchants';

  constructor(private http: HttpClient) {}
  /**
   * @desc Function to get chains
   * @param {number} page - The page number
   * @param {string} query - The search query
   * @return {Observable}
   */
  getChains(page: number, query: string): Observable<any> {
    const offset = page ? (page - 1) * this.PAGINATION_LIMIT : 0;
    return this.http
      .get(RESOURCES.CHAINS, {
        params: {
          query: query,
          limit: this.PAGINATION_LIMIT.toString(),
          offset: offset.toString(),
        },
      }).pipe(map(res => <any>res));
  }

  /**
   * @desc Query to get chain by id
   * @param {string} chainId - Id of the chain
   * @return {Observable}
   */
  getChainById(chainId: number): Observable<any> {
    return this.http.get(RESOURCES.CHAINS + '/' + chainId).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to delete a chain by id
   * @param {string} chainId - Id of the chain
   * @return {Observable}
   */
  deleteChain(chainId: number): Observable<any> {
    return this.http.delete(RESOURCES.CHAINS + '/' + chainId).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to create a new chain
   * @param {string} chainName - Name of the new chain
   * @return {Observable}
   */
  createChain(chainName: string): Observable<any> {
    const params = {
      name: chainName,
    };
    return this.http.post(RESOURCES.CHAINS, params, { observe: 'response' }).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to add merchant to a chain
   * @param {string} chainId - Id of the chain for the merchant to be added
   * @param {string} merchantId - Id of the merchant to be added
   * @return {Observable}
   */
  addMerchantToChain(chainId: number, merchantId: number): Observable<any> {
    return this.http.put(RESOURCES.CHAINS + '/' + chainId + this.merchantsSegment, [merchantId]).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to remove a merchant from a chain
   * @param {string} chainId - Id of the chain for the merchant to be removed
   * @param {string} merchantId - Id of the merchant to be removed
   * @return {Observable}
   */
  removeMerchantFromChain(chainId: number, merchantId: number): Observable<any> {
    return this.http.delete(RESOURCES.CHAINS + '/' + chainId + this.merchantsSegment + '/' + merchantId).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to get employees from a chain
   * @param {string} chainId - Id of the chain for the employees to be gotten
   * @return {Observable}
   */
  getEmployeesFromChain(chainId: number): Observable<any> {
    return this.http.get(RESOURCES.CHAINS + '/' + chainId + '/employees').pipe(map(res => <any>res));
  }

  /**
   * @desc Function to update employee access for a chain
   * @param {string} chainId - Id of the chain for the employee access to be granted
   * @param {object} employee - Employee object to be updated
   * @return {Observable}
   */
  updateEmployeeAccess(chainId: number, employee: any): Observable<any> {
    return this.http.put(RESOURCES.CHAINS + '/' + chainId + '/employees/' + employee.id, employee).pipe(map(res => <any>res));
  }
}



// WEBPACK FOOTER //
// ./src/app/chains/chain.service.ts